"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavigationTracker = void 0;
var _react = require("react");
var _OptionalReactNativeNavigation = require("../optional/OptionalReactNativeNavigation");
var _usePostHog = require("./usePostHog");
function _useNavigationTrackerDisabled() {
  return;
}
function _useNavigationTracker(options, client) {
  var contextClient = (0, _usePostHog.usePostHog)();
  var posthog = client || contextClient;
  if (!_OptionalReactNativeNavigation.OptionalReactNativeNavigation) {
    return;
  }
  var routes = _OptionalReactNativeNavigation.OptionalReactNativeNavigation.useNavigationState(function (state) {
    return state === null || state === void 0 ? void 0 : state.routes;
  });
  var navigation = _OptionalReactNativeNavigation.OptionalReactNativeNavigation.useNavigation();
  var trackRoute = function trackRoute() {
    var _a, _b, _c;
    if (!posthog) {
      return;
    }
    var currentRoute = navigation.getCurrentRoute();
    if (!currentRoute) {
      return;
    }
    var state = currentRoute.state;
    var name = currentRoute.name,
      params = currentRoute.params;
    if ((_a = state === null || state === void 0 ? void 0 : state.routes) === null || _a === void 0 ? void 0 : _a.length) {
      var route = state.routes[state.routes.length - 1];
      name = route.name;
      params = route.params;
    }
    var currentRouteName = ((_b = options === null || options === void 0 ? void 0 : options.routeToName) === null || _b === void 0 ? void 0 : _b.call(options, name, params)) || name || 'Unknown';
    if (currentRouteName) {
      var properties = (_c = options === null || options === void 0 ? void 0 : options.routeToProperties) === null || _c === void 0 ? void 0 : _c.call(options, currentRouteName, params);
      posthog.screen(currentRouteName, properties);
    }
  };
  (0, _react.useEffect)(function () {
    if (!routes) {
      setTimeout(trackRoute, 1);
      return;
    }
    trackRoute();
  }, [routes]);
}
var useNavigationTracker = _OptionalReactNativeNavigation.OptionalReactNativeNavigation ? _useNavigationTracker : _useNavigationTrackerDisabled;
exports.useNavigationTracker = useNavigationTracker;